<template>
    <ul class="filter" v-if="!disableFilters">
        <li class="filter__item" v-if="branches">
            <label for="brancheFilter" class="sr-only">{{ dictionary.ArticlesBranches }}</label>
            <select id="brancheFilter" v-model="branche" :disabled="isLoading">
                <option value="All">{{ dictionary.ArticlesBranches }}</option>
                <option v-for="brancheItem in branches" :key="brancheItem.Key" :value="brancheItem.Key">{{
                    brancheItem.Name
                }}
                </option>
            </select>
        </li>
        <li class="filter__item" v-if="industrys">
            <label for="industryFilter" class="sr-only">{{ dictionary.ArticlesIndustrys }}</label>
            <select id="industryFilter" v-model="industry" :disabled="isLoading">
                <option value="All">{{ dictionary.ArticlesIndustrys }}</option>
                <option v-for="industry in industrys" :key="industry.Key" :value="industry.Key">{{
                    industry.Name
                }}</option>
            </select>
        </li>
       
      
        <li class="filter__item" v-if="hasFilterApplied">
            <button type="button" @click="resetFilter">{{ dictionary.ArticlesResetFilter }}</button>
        </li>
    </ul>
    <ul class="articles-list__items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" class="article-item__link">
                    <div class="article-item__inner">
                        <div class="article-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                        </div>
                        <div class="article-item__text">
                            <div class="article-item__tags">
                                 <li class="article-item-tag" v-for="industry in article.IndustryTag" :key="industry">
                                    {{ industry }}
                                </li>
                                
                                <div class="article-item__tag" v-if="article.brancheTags">
                                    {{ article.brancheTags }}
                                </div>
                            </div>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-list__cta">
        <div class="articles-list__load-more" v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading">{{
                dictionary.ArticlesLoadMore
            }}</a>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/articlesApi/getArticles";
const defaultIndustryTag = "All";
const defaultBrancheTag = "All";
export default {
    name: "Articles",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            industrys: [],
            branches: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            articlesNodeId: 0,
            isResetting: false,
            disableFilters: false
        };
    },
    mixins: [
        bindRoute({
            industry: defaultIndustryTag,
            branche: defaultBrancheTag,
        }),
    ],
    watch: {
        industry: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        branche: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },

    },
    mounted() {
        this.articlesNodeId = this.$parent.articlesNodeId;
        this.pageSize = this.$parent.pageSize;
        this.disableFilters = this.$parent.disableFilters;

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getArticles(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                articlesNodeId: vm.articlesNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize
            };

            if (vm.industry != defaultIndustryTag) {
                object.industry = vm.industry;
            }

            if (vm.branche != defaultBrancheTag) {
                object.branche = vm.branche;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.industrys = data.Facets.Industrys;
                    vm.branches = data.Facets.Branches;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getArticles(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            // Get all cases up to, and including, the current page
            const initialPageSize = this.pageSize * this.page;
            this.getArticles(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getArticles(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.industry = defaultIndustryTag;
            vm.branche = defaultBrancheTag;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getArticles(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.industry != defaultIndustryTag ||
                this.branche != defaultBrancheTag
        }
    },
};
</script>